import React from "react";
import { Box, Typography, IconButton, Divider, Modal } from "@mui/material";
import { Close } from "@mui/icons-material";


export default function AddModalView(props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: "90vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    ...props.modalSx
  }

  const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "72px",
    padding: 2,
    ...props.headerSx
  }

  const contentStyle = (dividerVisible) => ({
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    // keep scrollbar inside rounded container
    scrollbarGutter: "stable",
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(32,32,32,0.25) transparent",
    "&::-webkit-scrollbar": {
      width: "10px"
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent"
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(32,32,32,0.22)",
      borderRadius: "999px",
      border: "3px solid transparent",
      backgroundClip: "content-box"
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "rgba(32,32,32,0.32)"
    },
    ...props.contentSx,
    // If divider is hidden and header draws its own border, no extra spacing needed.
    // Otherwise keep content flush under divider.
    ...(dividerVisible ? {} : {})
  })

  const showCloseButton = props.showCloseButton ?? true
  const showDivider = props.showDivider ?? true

  return (
    <Modal
      open={props.isOpen}
      onClose={() => props.setIsOpen(false)}
    >
      <Box
        sx={style}
      >
        <Box
          sx={headerStyle}
        >
          <Typography
            variant={props.titleVariant ?? "h5"}
            sx={props.titleSx}
          >
            {props.title}
          </Typography>

          {showCloseButton && (
            <IconButton
              onClick={() => props.setIsOpen(false)}
            >
              <Close />
            </IconButton>
          )}
        </Box>

        {showDivider && <Divider />}

        <Box sx={contentStyle(showDivider)}>
          {props.view}
        </Box>
      </Box>
    </Modal>
  )
}
